import React from "react";
import logoTrawlpack from "./assets/images/logotb.png";

const Head = (props) => {
 
  return (
  //   <img
  //   className="object-fill w-screen"
  //   src="https://media.graphassets.com/g7WdVTy2T96Gbz4OmGqV"
  //   alt=""
  // ></img>
    <div className=" background-jasa-top-kargo">
      <a href="/" className="mb-100 m-auto">
        <img className="w-60 mb-55"  src={logoTrawlpack} alt="" />
      </a>
      <div className="grid md:grid-cols-2">
        <div style={{textAlign: "-webkit-center", margin: "20px"}}>
          <div className="my-10">
            <img
              // style={{width:"100%" , paddingTop:140}}
              src="https://media.graphassets.com/eYrGMr2hQPev3R4A4iyu"
              alt=""
              // className="mb-5 align-center pr-30  w-10 md:h-4/5 md:w-3/4 "
            />
          </div> 
          <div className="text-center pt-18 mb-10">
            <h1 className="mb-5 text-3xl md:text-[38px] text-putih font-bold"> 
              Jadi Sultan Cargo <br/> Sekarang Juga !!!
            </h1>
            <a href="https://trawlben.netlify.app/mitra-space/">
              <button className="mb-5  px-4 py-2 text-putih bg-[#CD3936] rounded-xl  ">
                Gabung Mita-Space Trawlbens
              </button>
            </a> 
          </div>
        </div>
      </div>
    </div>   
  );
};

export default Head;
